import React, { useState, useEffect } from 'react';
import { postAPI } from '../../app/api';
import FacebookFeed from './FacebookFeed';
// import '../../styles/dynamic-footer.css';
import footerLogo from "../../assets/img/footer-logo.png"
import youtubeLogo from "../../assets/img/youtube-icon.png"
import fbLogo from "../../assets/img/fb-icon.png"
const { REACT_APP_BRANDURL } = process.env;

export default function Footer() {
    const [footerData, setFooterData] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch dynamic footer data
    useEffect(() => {
        fetchFooterData();
    }, []);

    const fetchFooterData = async () => {
        try {
            setLoading(true);
            const response = await postAPI('footer-data/fetchData', {});

            console.log('Footer API Response:', response);

            if (response?.status === 1 && response?.data) {
                console.log('Footer data fetched:', response.data);
                setFooterData(response.data);
            } else {
                console.warn('Failed to fetch footer data, using fallback');
                setFooterData([]);
            }
        } catch (error) {
            console.error('Error fetching footer data:', error);
            setFooterData([]);
        } finally {
            setLoading(false);
        }
    };

    // Group sections by position
    const getSectionsByPosition = (position) => {
        return footerData
            .filter(section => section.position === position && section.is_active === 1)
            .sort((a, b) => a.order_index - b.order_index);
    };

    // Render a single footer section
    const renderSection = (section) => {
        const style = {
            color: section.text_color || '#ffffff',
            fontFamily: section.font_family || 'Arial',
            fontSize: `${section.font_size || 14}px`,
            fontWeight: section.font_weight || 'normal'
        };

        switch (section.section_type) {
            case 'heading':
                return (
                    <h5 key={section.id} className="mb-3 fw-semibold">
                        {section.content}
                    </h5>
                );

            case 'text':
                return (
                    <p key={section.id} className="mb-2">
                        {section.content}
                    </p>
                );

            case 'link':
                return (
                    <p key={section.id} className="mb-2">
                        <a href={section.link_url || '#'} target="_blank" rel="noopener noreferrer">
                            {section.content}
                        </a>
                    </p>
                );

            case 'icon_link':
                return (
                    <a key={section.id} href={section.link_url || '#'} target="_blank" rel="noopener noreferrer"
                        className="d-block mb-2">
                        {section.icon_class && <i className={section.icon_class}></i>} {section.content}
                    </a>
                );

            case 'image':
                return (
                    <div key={section.id} className="mb-2">
                        <img
                            src={section.image_url || section.content}
                            alt="Footer Image"
                            className="img-fluid"
                            style={{ maxHeight: '100px' }}
                            onError={(e) => { e.target.style.display = 'none'; }}
                        />
                    </div>
                );

            default:
                return (
                    <p key={section.id} className="mb-2" style={style}>
                        {section.content}
                    </p>
                );
        }
    };

    // Fallback content for each column if no dynamic data exists
    const fallbackContent = {
        1: [], // Column 1 - Logo area (keep fixed)
        2: [ // Column 2 - Useful Links
            { id: 'fallback-2-1', section_type: 'heading', content: 'Useful Links', text_color: '#ffffff', font_weight: 'bold' },
            { id: 'fallback-2-2', section_type: 'link', content: '» Home', link_url: '/', text_color: '#ffffff' },
            { id: 'fallback-2-3', section_type: 'link', content: '» About us', link_url: '/about', text_color: '#ffffff' },
            { id: 'fallback-2-4', section_type: 'link', content: '» Alumni', link_url: '/alumni', text_color: '#ffffff' },
            { id: 'fallback-2-5', section_type: 'link', content: '» Gallery', link_url: '/gallery', text_color: '#ffffff' },
            { id: 'fallback-2-6', section_type: 'link', content: '» Contact Us', link_url: '/contact', text_color: '#ffffff' },
            { id: 'fallback-2-7', section_type: 'link', content: '» Terms & Conditions', link_url: '/terms-and-conditions', text_color: '#ffffff' },
            { id: 'fallback-2-8', section_type: 'link', content: '» Privacy Policy', link_url: '/privacy-policy', text_color: '#ffffff' },
            { id: 'fallback-2-9', section_type: 'link', content: '» Refund Policy', link_url: '/refund-policy', text_color: '#ffffff' },
            { id: 'fallback-2-10', section_type: 'link', content: '» Cancellation Policy', link_url: '/cancellation-policy', text_color: '#ffffff' }
        ],
        3: [ // Column 3 - Contact
            { id: 'fallback-3-1', section_type: 'heading', content: 'Contact', text_color: '#ffffff', font_weight: 'bold' },
            { id: 'fallback-3-2', section_type: 'icon_link', content: 'C-K-14, 2nd Avenue, CK Block, Sector II, Bidhannagar, Kolkata, West Bengal 700091', icon_class: 'fa fa-map-marker', text_color: '#ffffff', font_size: '13' },
            { id: 'fallback-3-3', section_type: 'icon_link', content: '033 2321 2261', link_url: 'tel:+9103323212261', icon_class: 'fa fa-phone', text_color: '#ffffff', font_size: '13' },
            { id: 'fallback-3-4', section_type: 'icon_link', content: 'info@becollege.com', link_url: 'mailto:info@becollege.com', icon_class: 'fa fa-envelope', text_color: '#ffffff', font_size: '13' }
        ],
        4: [] // Column 4 - Facebook/Social (keep fixed)
    };

    return (
        <>
            <footer className="footer-section pt-5">
                <div className="container-xxl container-fluid">
                    <div className="row align-items-start">
                        {/* Column 1 - Logo Area (Fixed) */}
                        <div className="col-lg-4 col-md-4 text-center mb-4">
                            <img src={footerLogo} alt="logo" className="img-fluid mb-3" />
                            {/* Dynamic content for column 1 */}
                            <div>
                                {getSectionsByPosition(1).length > 0 ? (
                                    getSectionsByPosition(1).map(section => renderSection(section))
                                ) : (
                                    fallbackContent[1].map(section => renderSection(section))
                                )}
                            </div>
                        </div>

                        {/* Column 2 - Dynamic Links Area */}
                        <div className="col-lg-3 col-md-8 mb-4">
                            {loading ? (
                                <div className="placeholder-glow">
                                    <div className="placeholder col-6" style={{ height: '20px' }}></div>
                                    <div className="placeholder col-4" style={{ height: '15px' }}></div>
                                    <div className="placeholder col-5" style={{ height: '15px' }}></div>
                                    <div className="placeholder col-6" style={{ height: '15px' }}></div>
                                </div>
                            ) : (
                                <div>
                                    {getSectionsByPosition(2).length > 0 ? (
                                        getSectionsByPosition(2).map(section => renderSection(section))
                                    ) : (
                                        <div className="footer-links">
                                            {fallbackContent[2].map(section => renderSection(section))}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        {/* Column 3 - Dynamic Contact Area */}
                        <div className="col-lg-4 col-md-8 mb-4 contact-details">
                            {loading ? (
                                <div className="placeholder-glow">
                                    <div className="placeholder col-6" style={{ height: '20px' }}></div>
                                    <div className="placeholder col-8" style={{ height: '15px' }}></div>
                                    <div className="placeholder col-5" style={{ height: '15px' }}></div>
                                    <div className="placeholder col-7" style={{ height: '15px' }}></div>
                                </div>
                            ) : (
                                <div>
                                    <h5 className='mb-3 fw-semibold'>Contact</h5>
                                    <p className='text-light small'><i class="fa fa-map-marker me-2"></i>B E College Ex-Students Club<br></br> CK-14, Salt Lake, Sector-II, Kolkata - 700091, West Bengal, India.
                                    </p>
                                    <a className='text-light small mb-2' href='tel:(033) 4001-6318 '><i class="fa fa-phone me-2"></i>(033) 4001-6318 </a>
                                    <a className='text-light small mb-1' href='mailto:becollegeexstudent@gmail.com'><i class="fa fa-envelope me-2"></i>becollegeexstudent@gmail.com </a>
                                    {/* {getSectionsByPosition(3).length > 0 ? (
                                        getSectionsByPosition(3).map(section => renderSection(section))
                                    ) : (
                                        <div>
                                            {fallbackContent[3].map(section => renderSection(section))}

                                        </div>
                                    )} */}
                                    <div className="d-flex align-items-center justify-content-start social-media mt-3">
                                        <a href="https://www.facebook.com/BECollegeExstudentsClub/" target="_blank" rel="noopener noreferrer">
                                            <img src={fbLogo} alt="facebook" />
                                        </a>
                                        <a href="https://www.youtube.com/@b.e.collegeex-studentsclub9837" target="_blank" rel="noopener noreferrer">
                                            <img src={youtubeLogo} alt="youtube" />
                                        </a>
                                    </div>
                                </div>
                            )}
                        </div>
                        {/* <div className="col-lg-3 col-md-4 mb-0">
                            <div className="mb-3">
                                {getSectionsByPosition(4).length > 0 && (
                                    getSectionsByPosition(4).map(section => renderSection(section))
                                )}
                            </div>
                            <div className="p-0 bg-white rounded shadow-sm" style={{ background: "#ffffff" }}>
                                <FacebookFeed />
                            </div>
                        </div> */}
                    </div>
                </div>

                {/* Fixed Footer Bottom */}
                <div className="footer-bottom text-center py-3">
                    <small className="text-light">&copy; B E College Ex-Students Club | Designed & Maintained by:
                        <a href="https://retechprime.com" target='_blank' className="text-warning"> ReTechPrime</a>
                    </small>
                </div>
            </footer>
        </>
    );
}